// Whether a control sits in the Akaiva sign-in frame (src/shell/authFrame). There the controls take
// the admin console's sign-in look, so every Akaiva sign-in reads the same (constitution 1.1.0):
// the red button and sentence-case labels, underlined blue links, the eye toggle on passwords.
import { createContext, useContext } from "react";

export const SignInFrameContext = createContext(false);

export function useInSignInFrame(): boolean {
  return useContext(SignInFrameContext);
}
